import { render, staticRenderFns } from "./TipoRegimen.vue?vue&type=template&id=e2eda482&scoped=true"
import script from "./TipoRegimen.vue?vue&type=script&lang=js"
export * from "./TipoRegimen.vue?vue&type=script&lang=js"
import style0 from "./TipoRegimen.vue?vue&type=style&index=0&id=e2eda482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eda482",
  null
  
)

export default component.exports